import { Component, Input } from '@angular/core';

import { TPropertyStatus } from '@shared/models/properties';

@Component({
  selector: 'app-property-list-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
})
export class PropertyListStatusComponent {
  @Input({ required: true }) status: TPropertyStatus = 'OPEN';
}
